import {
  Card,
  CardContent,
  CardHeader,
  Divider,
  Link,
  List,
  ListItem,
  ListItemText,
  ListSubheader,
  useTheme,
} from '@material-ui/core';
import OpenInNew from '@material-ui/icons/OpenInNew';

import { Link as JumpToLink } from 'react-router-dom';
import { CpeCardProps } from './types';

import { useStyles } from './styles';

export function AccountSupportCard(props: CpeCardProps) {
  const theme = useTheme();

  const { variant } = props;
  const classes = useStyles();
  let cardClass = '';
  let cardContentClass = '';
  if (variant === 'gridItem') {
    cardClass = classes.gridItemCard;
    cardContentClass = classes.gridItemCardContent;
  } else if (variant === 'fullHeight') {
    cardClass = classes.fullHeightCard;
    cardContentClass = classes.fullHeightCardContent;
  }

  function CustomListItem(cliProps: {
    linkTo: string;
    linkText: string;
    subheaderText?: string;
  }) {
    return (
      <ListItem button>
        <ListItemText>
          <Link underline="hover">
            <JumpToLink
              target="_blank"
              to={cliProps.linkTo}
              style={{ color: theme.palette.link }}
            >
              <div style={{ display: 'flex' }}>
                {cliProps.linkText} &nbsp;
                <OpenInNew />
              </div>
            </JumpToLink>
          </Link>
          {cliProps.subheaderText && (
            <ListSubheader>{cliProps.subheaderText}</ListSubheader>
          )}
        </ListItemText>
      </ListItem>
    );
  }

  return (
    <Card className={cardClass}>
      <CardHeader title="Support" />
      <Divider />
      <CardContent className={cardContentClass}>
        <List>
          <CustomListItem
            linkTo="https://principal.service-now.com/esc?id=kb_article&sysparm_article=KB0013818"
            linkText="Change the IdentityNow access profile owner for my workload"
            subheaderText="Include the account number(s) and the need to change the Access Profile Owner"
          />
          <CustomListItem
            linkTo="https://principal.service-now.com/esc?id=kb_article&sysparm_article=KB0016694"
            linkText="Change the IdentityNow governance group members for my workload"
          />
          <CustomListItem
            linkTo="https://principal.service-now.com/esc?id=sc_cat_item_guide&table=sc_cat_item&sys_id=c3de07241b70755454a1400abc4bcb75"
            linkText="Request general assistance for my account"
          />
        </List>
      </CardContent>
    </Card>
  );
}
